import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_CATALOG_RECORDS, GET_CATALOG_SINGLE_RECORD, TOGGLE_CART_RECORDS } from "../actions";
import { v4 as uuid_v4 } from 'uuid';

import {
  getRecordsSuccess,
  getRecordsError,
  getRecordSuccess,
  getRecordError,
  getToggleCartSuccess,
  getToggleCartError
} from "./actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";
import EnumRecordStates from "../../enums/enumRecordStates";
import EnumOrderStates from "../../enums/enumOrderStates";
import EnumLcids from "../../enums/enumLcid";
import moment from "moment";
import LocalStorageService from "../../services/storage/LocalStorageService";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
const localStorageService = LocalStorageService.getService();

export function* watchGetRecords() {
  yield takeEvery(GET_CATALOG_RECORDS, getRecordList);
}

export function* watchGetRecord() {
  yield takeEvery(GET_CATALOG_SINGLE_RECORD, getRecord);
}

export function* watchGetToggleCartRecord() {
  yield takeEvery(TOGGLE_CART_RECORDS, getCartRecord);
}

const getRecordListAsync = async (payload) => {
  try {
    let responseObject = {};
    if (payload.searchText == undefined) {
      payload.searchText = "";
    }

    if (payload.termIds == undefined) {
      payload.termIds = "";
    }

    if (payload.vocabularyId == undefined) {
      payload.vocabularyId = ""
    }

    responseObject = await centralApiAxios.get(`catalog_items?pageSize=5&sort_by=1&trashed=false&search_text=` + payload.searchText + "&categoryTermIds=" + payload.termIds + "&vocabularyId=" + payload.vocabularyId + "&pageNumber=" + payload.pageNumber + "&record_state=" + EnumRecordStates.Current + "&current_date_time=" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss a'), getActivityHeadersUpdated(payload));

    return {
      recordList: responseObject.data.items,
      total_item_count: responseObject.data.totalItemCount,
      message: null,
    };
  } catch (error) {
    return {
      message: 'Failed to get contact. ' + error
    }
  }
}

const getCartRecordAsync = async (payload) => {

  let orderId = payload.orderId;

  try {
    if (orderId > 0) {
      //create line items
      let lineItem = {};
      lineItem.RecordType = EnumRecordTypes.LineItem;
      lineItem.RecordState = EnumRecordStates.Current;
      lineItem.lcid = EnumLcids.English;
      lineItem.depth = 1;
      lineItem.displayhidden = 0;
      lineItem.feeOverrideType = 1;

      lineItem.catalogItemId = payload.catalog.catalogItemId;
      lineItem.nodeId = payload.catalog.catalogItemId;
      lineItem.price = payload.catalog.costPerUnit;
      lineItem.SubTotalAmount = payload.catalog.costPerUnit;
      lineItem.TotalAmount = lineItem.SubTotalAmount;
      lineItem.description = payload.catalog.name;
      lineItem.quantity = 1;
      lineItem.orderId = orderId;

      let responseObject = await centralApiAxios.post(`line_items`, lineItem, getActivityHeadersUpdated(payload));

      return {
        orderId: orderId,
        lineItemAdded: responseObject.data,
        message: null,
      };
    }
    else {

      //create order
      let cartCreateRequest = {
        "orderCreateRequest": {
          "trashed": false,
          "recordType": EnumRecordTypes.Orders,
          "recordState": EnumRecordStates.Current,
          "orderState": EnumOrderStates.Open,
          "orderGuid": uuid_v4(),
          "primaryContactId": localStorageService.getUserInfo("user_contactId")
        },
        lineItems: [
          {
            "recordState": EnumRecordStates.Current,
            "recordType": EnumRecordTypes.LineItem,
            "lcid": EnumLcids.English,
            "depth": 1,
            "displayhidden": 0,
            "feeOverrideType": 1,
            "catalogItemId": payload.catalog.catalogItemId,
            "nodeId": payload.catalog.catalogItemId,
            "price": payload.catalog.costPerUnit,
            "description": payload.catalog.name,
            "quantity": 1,
            "SubTotalAmount": payload.catalog.costPerUnit,
            "TotalAmount": payload.catalog.costPerUnit,
          }
        ]
      };

      let responseObject = await centralApiAxios.post("carts", cartCreateRequest, getActivityHeadersUpdated(payload));


      return {
        orderId: responseObject.data.orderResponse.orderId,
        lineItemAdded: responseObject.data.lineItems[0],
        message: null,
      };
    }

  } catch (error) {
    return {
      message: 'Failed to get contact. ' + error
    }
  }
}

function* getRecordList({ payload }) {
  try {
    const pageSize = 5;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      let recordListParam = {
        records: recordListReturned.recordList,
        searchText: recordListReturned.searchText,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getRecordsSuccess(recordListParam));
    } else {
      yield put(getRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordsError(error));
  }
}

const getRecordAsync = async (payload) => {
  let responseObject = {};

  try {
    if (payload.catalogItemId > 0) {
      responseObject = await centralApiAxios.get(`catalog_items/${payload.catalogItemId}?lcid=1033`);
    }
  }
  catch (e) {
  }


  return {
    catalogItemSingle: responseObject.data,
    catalogItemId: responseObject.data.catalogItemId,
    message: ""
  };


}

function* getRecord({ payload }) {
  try {
    const recordListReturned = yield call(getRecordAsync, payload);
    if (!recordListReturned.message) {
      yield put(getRecordSuccess(recordListReturned.catalogItemSingle));
    } else {
      yield put(getRecordError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordError(error));
  }
}

function* getCartRecord({ payload }) {
  try {
    const recordListReturned = yield call(getCartRecordAsync, payload);

    if (!recordListReturned.message) {
      yield put(getToggleCartSuccess(recordListReturned));
    } else {
      yield put(getToggleCartError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getToggleCartError(error));
  }
}

export default function* rootSaga() {
  yield all([fork(watchGetRecords)]);
  yield all([fork(watchGetRecord)]);
  yield all([fork(watchGetToggleCartRecord)])
}

